<template>
  <div id="numEcharts" style="width: 100%; height: 100%"></div>
</template>
<script>
import * as echarts from "echarts";
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {
    var numEcharts = document.getElementById("numEcharts");
    var charts = echarts.init(numEcharts);
    var option = {
      tooltip: {
        trigger: "axis",
      },
      legend: {
        textStyle: {
          color: "#fff",
        },
        top: "5%",
      },
      grid: {
        left: "2%",
        right: "2%",
        bottom: "3%",
        top: "20%",
        containLabel: true,
      },
      calculable: true,
      xAxis: [
        {
          type: "category",
          data: ["1月", "2月", "3月", "4月", "5月", "6月", "7月"],
          axisLabel: {
            color: "white",
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "white",
            },
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          name: "单位/次",
          axisLabel: {
            color: "white",
            formatter: "{value}次",
          },
          nameTextStyle: {
            color: "white",
          },
          splitLine: {
            show: true,
            lineStyle: {
              // 在 lineStyle 中设置线的样式
              color: "gray", // 将线的颜色设置为灰色
              opacity: 0.5,
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "white",
            },
          },
        },
      ],
      series: [
        {
          name: "溯源查询次数",
          type: "bar",
          barWidth: "40%",
          barGap: 0,
          data: [1350, 1620, 1320, 1500, 1640, 1850, 1750],
          tooltip: {
            valueFormatter: function (value) {
              return value + "次";
            },
          },
          itemStyle: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1, // 这四个参数分别表示渐变的起点 (x1, y1) 与终点 (x2, y2)
              [
                { offset: 0, color: "#f2c347" }, // 0% 处的颜色
                { offset: 1, color: "#287ce7" }, // 100% 处的颜色
              ]
            ),
          },
        },
      ],
    };
    charts.setOption(option);
    window.addEventListener("resize", () => {
      charts.resize();
    });
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>
